import React from "react";
import SwiperCore, { Autoplay, EffectCoverflow, Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "./Dashboard.css";
import { useTranslation } from "react-i18next";
import newDbImg from "../../assets/dashboard/image1.png";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import TopProductsSlider from "./TopProductsSlider";
import i18next from "i18next";
import axios from "../../components/utils/Interceptors";
import { useGetAllOrders } from "../../api/hooks/orders/useGetAllOrders";
import { useDashboardDetails } from "../../api/hooks/dashboard/useDashboardDetails";
import { useFetchCurrentPlan, useTopProducts } from "../../api/hooks/products";
import PackageAlert from "./PackageAlert";
import DashboardSummaryCards from "./DashboardSummaryCards";
import CurrentPlanCard from "./CurrentPlanCard";
import LatestOrdersTable from "./LatestOrdersTable";
import OrderStatusCards from "./OrderStatusReports";
import SalesChart from "./SalesChart";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const { t } = useTranslation();
  SwiperCore.use([EffectCoverflow, Autoplay, Pagination]);
  const [latestOrders, setLatestOrders] = useState([]);
  const [dashboardData, setdashboardData] = useState(null);
  const [topProducts, setTopProducts] = useState([]);
  const [currentPlan, setCurrentPlan] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const [orderCount, setOrderCount] = useState(0);
  const [earnings, setEarnings] = useState(0);
  const [date, setDate] = useState("");

  const { data: ordersData, isSuccess: ordersSuccess } = useGetAllOrders();
  const { data: dashboardDataQ, isSuccess: dashboardSuccess } = useDashboardDetails();
  const { data: topProductsData, isSuccess: topProductsSuccess } = useTopProducts();
  const { data: currentPlanData, isSuccess: currentPlanSuccess } = useFetchCurrentPlan();

  // Latest orders, order count, earnings
  useEffect(() => {
    if (ordersSuccess && ordersData?.status_code === 200) {
      const latest = ordersData.data.slice(-3);
      setLatestOrders(latest);

      let order = 0;
      let total = 0;
      ordersData.data.forEach((d) => {
        if (d.order_status === 2) {
          order += 1;
          total += d.order_price;
        }
      });
      setOrderCount(order);
      setEarnings(total);
    }
  }, [ordersSuccess, ordersData]);

  // Dashboard data & graph
  useEffect(() => {
    if (dashboardSuccess && dashboardDataQ?.status_code === 200) {
      setdashboardData(dashboardDataQ);
      setGraphData(dashboardDataQ.monthWiseSales);
    }
  }, [dashboardSuccess, dashboardDataQ]);

  // Top products
  useEffect(() => {
    if (topProductsSuccess && topProductsData?.status_code === 200 && topProductsData.data.length > 0) {
      setTopProducts(topProductsData.data);
    }
  }, [topProductsSuccess, topProductsData]);

  // Current plan & formatted date
  useEffect(() => {
    if (currentPlanSuccess && currentPlanData?.status_code === 200 && currentPlanData.data.length > 0) {
      const plan = currentPlanData.data[0];

      if (plan.to_date) {
        const toDate = new Date(plan.to_date);
        const formattedDate = new Intl.DateTimeFormat("en-GB").format(toDate);
        setDate(formattedDate);
      }

      setCurrentPlan(plan);
    }
  }, [currentPlanSuccess, currentPlanData]);

  const selectLanguage = i18next.language;

  return (
    <>
      <Helmet>
        <title>{t("vender_dash")}</title>
      </Helmet>
      <h2 className="text-title text-lg md:text-2xl pb-2">
        {t("v_dash_title")}
      </h2>

      <div>
        <PackageAlert planName={currentPlan?.plan_name} expiryDate={date} />

        {/* First ROW */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-5">
          <DashboardSummaryCards
            orderCount={orderCount}
            earnings={earnings}
            dashboardData={dashboardData}
            newDbImg={newDbImg}
          />

          {/* current package */}
          <CurrentPlanCard
            currentPlan={currentPlan}
            dashboardData={dashboardData}
            date={date}
          />
        </div>

        {/* second ROW */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Latest Orders */}
          <LatestOrdersTable latestOrders={latestOrders} />

          {/* order reports */}
          <OrderStatusCards
            dashboardData={dashboardData}
          />
        </div>

        {/* Third Row */}
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2  gap-5 mb-8">
          <SalesChart
            selectLanguage={selectLanguage}
            graphData={graphData}
          />
        </div>

        {/* Top Products */}
        <div className="my-12 mb-16">
          <TopProductsSlider type={"vender"} user={user} dashboard={"Vendor"} />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
